<template>
<div class="formupload">
    <div class="formtitle1">
      {{property.name}}
      <span v-if="property.checked" class="ischeck">*</span>
       (最多{{property.num}}张)
    </div>
    <div class="el-icon-plus upload_icon"></div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {
        options: []
      }
    };
  }
};
</script>

